import { forwardRef, useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";

const OpenableLink = forwardRef(function OpenableLink(
  { to, children, className = "", as: Tag = "span", ...rest },
  ref,
) {
  const navigate = useNavigate();
  const [contextMenu, setContextMenu] = useState(null);

  const open = (event) => {
    if (!to) return;
    event?.stopPropagation?.();
    navigate(to);
  };
  const close = () => setContextMenu(null);

  const handleContextMenu = (event) => {
    if (!to) return;
    event.preventDefault();
    event.stopPropagation();
    setContextMenu({ mouseX: event.clientX + 2, mouseY: event.clientY - 6 });
  };

  return (
    <>
      <Tag
        ref={ref}
        className={className}
        onClick={open}
        onContextMenu={handleContextMenu}
        {...rest}
      >
        {children}
      </Tag>

      <Menu
        open={contextMenu !== null}
        onClose={close}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined
        }
      >
        <MenuItem
          onClick={() => {
            open();
            close();
          }}
        >
          <p>Open</p>
        </MenuItem>
        <MenuItem
          onClick={() => {
            window.open(to, "_blank");
            close();
          }}
        >
          <p>Open in New Tab</p>
        </MenuItem>
      </Menu>
    </>
  );
});

export default OpenableLink;
